// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8ee4bc66","732":"a5958b66","977":"c9adb8ed"}[chunkId] + ".chunk.js";
};